import { MouseEvent, ReactElement } from 'react';
import { UserRole } from '@synergy/models';

import { AccessControl } from '../../access-control/access-control';
import { FavoriteIconButton } from '../../favorite-button/favorite-icon-button';
import { useAppSelector } from '../../../../store/store';
import { useArticleCardContext } from '../article-card';
import { userSelector } from '../../../store/configuration-selectors';

export const ArticleCardFavoriteButton = (): ReactElement => {
    const user = useAppSelector(userSelector);
    const { article, onToggleFavorite } = useArticleCardContext();

    const handleToggleFavorite = (e: MouseEvent): void => {
        e.preventDefault();
        onToggleFavorite?.();
    };

    return (
        <AccessControl user={user} allowedRoles={[UserRole.ShopUser, UserRole.ShopAdmin]}>
            <FavoriteIconButton onClick={handleToggleFavorite} isFavorite={article.isFavorite} />
        </AccessControl>
    );
};
